require('./bootstrap');

import { createApp, h } from 'vue';
import { createStore } from 'vuex'
import store from './Store'
import { createInertiaApp } from '@inertiajs/vue3';
import VueSweetalert2 from "vue-sweetalert2";
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
const { RayPlugin } = require('vue-ray');
const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import '@imengyu/vue3-context-menu/lib/vue3-context-menu.css'
import ContextMenu from '@imengyu/vue3-context-menu'
const app = createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => require(`./Pages/${name}.vue`),
    progress: { color: '#01A049', showSpinner: false, includeCSS: true },
    setup({ el, App, props, plugin }) {
        return createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(VueSweetalert2)
            // .use(RayPlugin, { interceptErrors: true, host: '127.0.0.1', port: 23517 })
            .use(store)
            .use(ContextMenu)
            .component('QuillEditor', QuillEditor)
            .component('v-select', vSelect)
            .mixin({ methods: { route, titleCase: str => str.replace (/^[-_]*(.)/, (_, c) => c.toUpperCase())       // Initial char (after -/_)
                        .replace (/[-_]+(.)/g, (_, c) => ' ' + c.toUpperCase()) } })
            .mixin({
                methods: {
                    number_format(nStr) {
                        nStr += '';
                        let x = nStr.split('.');
                        let x1 = x[0];
                        let x2 = x.length > 1 ? '.' + x[1] : '';
                        let rgx = /(\d+)(\d{3})/;
                        while (rgx.test(x1)) {
                            x1 = x1.replace(rgx, '$1' + ',' + '$2');
                        }
                        return x1 + x2;
                    },
                      formatCurrency (value, currencyCode, showSymbol = false) {

                        const localFormat = {style: 'currency', currency: currencyCode, currencyDisplay: showSymbol === false ? 'code' : 'symbol'}
                        let result = Intl.NumberFormat('de-DE', localFormat).format(value)
                        if(showSymbol === false) {
                          result = result.replace(/[a-z]{3}/i, "").trim()
                        }
                          result = result.toLocaleString();
                        return result
                      }
                },
              })
            .mount(el);
    },
});
